import { useEffect } from 'react';

/**
 * Hook for handling wheel events in the Gantt chart
 * - Timeline header: horizontal zoom
 * - Task area: vertical scroll (default)
 * - Ctrl/Cmd + wheel: zoom anywhere
 * - Shift + wheel: horizontal scroll
 */
export const useGanttWheel = (chartRef, smoothZoom) => {
  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;

    const handleWheel = (e) => {
      // Check what we're hovering over
      const isOverTimeline = e.target.closest('.gantt-timeline-header__timeline, .gantt-timeline-header__columns, .gantt-timeline-header__groups');
      const isOverSidebar = e.target.closest('.gantt-row__sidebar, .gantt-timeline-header__sidebar');
      const isOverTaskArea = e.target.closest('.gantt-row__timeline, .gantt-view__task-list');
      
      // Hovering over TIMELINE HEADER = horizontal ZOOM
      if (isOverTimeline) {
        e.preventDefault();
        smoothZoom(e.deltaY, e.clientX);
        return;
      }
      
      // Ctrl/Cmd + wheel anywhere = zoom (centered on mouse position)
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        smoothZoom(e.deltaY, e.clientX);
        return;
      }
      
      // Over task area (not sidebar) = normal vertical scroll (let browser handle)
      if (isOverTaskArea && !isOverSidebar) {
        // Just let the default scroll happen
        return;
      }
      
      // Shift + wheel = horizontal scroll (works anywhere)
      if (e.shiftKey) {
        e.preventDefault();
        chart.scrollLeft += e.deltaY;
        return;
      }
    };

    chart.addEventListener('wheel', handleWheel, { passive: false });
    return () => chart.removeEventListener('wheel', handleWheel);
  }, [chartRef, smoothZoom]);
};

export default useGanttWheel;
